module.exports = __webpack_public_path__ + "img/icon_open_code.fb9bd086.jpg";